module.exports = __webpack_public_path__ + "img/more.7aba3511.png";